export const decorationAndSuggestionStyles = `    
      .template-variable-decoration {
        background-color: #CBC1F640 !important;
        border-radius: 4px;
      }
      .template-variable-inline {
        font-family: "DM Mono", "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace !important;
        font-weight: 400 !important;
        font-size: 13px !important;
      }

      .ime-input {
        background-color: transparent !important;
      }
      
      /* Monaco's own 430px is too narrow for playbook token names. Widening it here makes the
         widget overhang the right edge of the window; keepSuggestWidgetOnScreen puts it back. */
      .monaco-editor .suggest-widget {
        background-color: var(--background-color-primary) !important;
        border: 1px solid var(--border-color-primary) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
        border-radius: 8px !important;
        width: 600px !important;
        max-width: calc(100vw - 30px) !important;
      }

      /* Push the .right column (which contains .details-label, rendered from
         CompletionItem.detail) to the far right of each suggestion row. Monaco's .main is a
         flexbox with justify-content:space-between, but it shrinks to its content by default,
         so the columns sit clustered at the start. Forcing .main to fill its parent activates
         the space-between behavior and pushes the detail to the row's right edge. */
      .monaco-editor .suggest-widget .monaco-list .monaco-list-row > .contents > .main {
        width: 100% !important;
      }

      /* Monaco shrinks .right four times faster than the label, so a long token name eats the
         data type first. Pin it instead — the label ellipsizes — capped at half the row so an
         unusually long type can't squeeze the label out entirely. */
      .monaco-editor .suggest-widget .monaco-list .monaco-list-row > .contents > .main > .right {
        flex: 0 0 auto !important;
        max-width: 50% !important;
      }

      /* Hide the readMore carat — it's absolutely positioned at right:10px of .right and
         overlays the details text. We don't ship documentation for these completions, so the
         carat has nothing to expand and is just visual noise. */
      .monaco-editor .suggest-widget .monaco-list .monaco-list-row > .contents > .main > .right > .readMore {
        display: none !important;
      }

      .monaco-editor .suggest-widget .monaco-list .monaco-list-row {
        background-color: transparent !important;
        color: var(--text-color-secondary) !important;
        border-radius: 6px !important;
        padding-left: 8px !important;
        font-family: "DM Mono", "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace !important;
      }

      /* Monaco colors labels from its own theme var, which would win over the row color above. */
      .monaco-editor .suggest-widget .monaco-list .monaco-list-row .monaco-icon-label,
      .monaco-editor .suggest-widget .monaco-list .monaco-list-row .monaco-highlighted-label,
      .monaco-editor .suggest-widget .monaco-list .monaco-list-row .monaco-highlighted-label .highlight {
        color: inherit !important;
      }

      .monaco-editor .suggest-widget .monaco-list .monaco-list-row .details-label {
        color: var(--text-color-tertiary) !important;
      }

      .monaco-editor .suggest-widget .monaco-list .monaco-list-row.focused,
      .monaco-editor .suggest-widget .monaco-list .monaco-list-row:hover {
        background-color: var(--background-color-secondary) !important;
        color: var(--text-color-primary) !important;
      }

      /* Suggestion details panel styling */
      .monaco-editor .suggest-details {
        background-color: var(--background-color-primary) !important;
        border: 1px solid var(--border-color-primary) !important;
        border-radius: 8px !important;
        color: var(--text-color-primary) !important;
      }

      .monaco-editor .suggest-details .header {
        background-color: var(--background-color-secondary) !important;
        border-bottom: 1px solid var(--border-color-tertiary) !important;
        color: var(--text-color-primary) !important;
      }
    `;
